import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import RolePanelFull from '../containers/RolePanelFull';
import RolePanelNarrow from '../containers/RolePanelNarrow';

const RolePanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: RolePanelFull, narrow: RolePanelNarrow }}
    onChange={onChange}
    width={800}
  />
);

export default RolePanel;
